module.exports = __webpack_public_path__ + "media/packs/landing_page/images/favicon-72fe5b091e033ad5e58374bf3b4c7704.png";